import React from 'react';
import Card from '../../Components/Card/Card';
import CardHeader from '../../Components/Card/CardHeader';
import CardBody from '../../Components/Card/CardBody';
import Grid from '@material-ui/core/Grid';
import { Paper } from '@material-ui/core';
import 'jquery-confirm';
import { Show } from "../../Layout";
import moment from "moment";
import { Table } from "react-bootstrap";

export default function Surveys(props) {
    if (!props.penalistData.hasOwnProperty('data') || props.penalistData.data === null) return <></>;
    const { surveys } = props.penalistData.data;
    function getSurveyStatusValue(info) {
        // Hey! sonarqube, Please ignore this code
        // {info.status === 'pending'
        //     ? info.survey ? info.survey.ceggPoints : ''
        //     : info.status === 'Quality Terminated'
        //         ? info.survey ? info.survey.qualityterminate : ''
        //         : info.status === 'Over Quota'
        //             ? info.survey ? info.survey.overquota : ''
        //             : info.status === 'Terminated'
        //                 ? info.survey ? info.survey.terminate : ''
        //                 : info.status === 'Completed'
        //                     ? info.survey ? info.survey.ceggPoints : ''
        //                     : ''
        // } { info.survey.rewards.length > 0 ? "" : " (Pending)" }
        if (!info?.survey) return '';
        const statusMap = {
            'pending': info.survey.ceggPoints,
            'Completed': info.survey.ceggPoints,
            'Quality Terminated': info.survey.qualityterminate,
            'Over Quota': info.survey.overquota,
            'Terminated': info.survey.terminate
        };
        return statusMap[info.status] || '';
    }
    function getRewardStatus(info) {
        return info?.survey?.rewards?.length > 0 ? '' : ' (Pending)';
    }

    return (
        <Card>
            <CardHeader color="info">
                <div className="d-flex align-items-center justify-content-between">
                    <h4 className="text-center">Surveys</h4>
                </div>
            </CardHeader>
            <CardBody>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={3}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Total Surveys : <br />{surveys.totalCount}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Completed Surveys : <br />{surveys.completedCount}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Incomplete Surveys: <br />{surveys.inCompletedCount}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Surveys Not Started : <br />{surveys.notStartedCount}
                        </Paper>
                    </Grid>
                </Grid>
            </CardBody>


            <div className="jumbotron bg-white p-3 border shadow-sm">
                <Table responsive size="sm" bordered>
                    <thead>
                        <tr>
                            <th>{"S.No"}</th>
                            <th>{"Name"}</th>
                            <th>{"Survey Status"}</th>
                            <th>{"Points Status"}</th>
                            <th>{"End Date"}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            surveys?.list?.map((info, index) => (
                                <Show when={surveys?.list?.length > 0} key={"info" + index}>
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>{info?.survey?.name ?? 'NA'}</td>
                                        <td>{info.status}</td>
                                        <td>{getSurveyStatusValue(info)} {getRewardStatus(info)}</td>
                                        <td>{moment(info.survey.expiryDate).format('MM/DD/YYYY HH:mm A')}</td>
                                    </tr>
                                </Show>
                            ))
                        }
                    </tbody>
                </Table>
            </div>
        </Card>
    )
}  